import PropTypes from 'prop-types';
import React from 'react';
import { styled } from '@mui/material/styles';

export const Logo = styled(
  React.forwardRef((props, ref) => {
    // eslint-disable-next-line react/prop-types
    const { variant, ...other } = props;

    const color = variant === 'light' ? '#ffffff' : '#ff0101';
    return (
      <svg
        ref={ref}
        version="1.0"
        xmlns="http://www.w3.org/2000/svg"
        width="58.000000pt"
        height="49.000000pt"
        viewBox="0 0 58.000000 49.000000"
        preserveAspectRatio="xMidYMid meet"
        {...other}>
        <g transform="translate(0.000000,49.000000) scale(0.100000,-0.100000)" fill="#000000" stroke="none">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9 486 c-2 -2 -3 -113 -1 -245 l3 -241 284 0 285 0 0 155 0 155 -190
0 -190 0 0 -65 0 -64 118 -3 c109 -3 117 -4 117 -23 0 -19 -8 -20 -142 -23
l-143 -3 0 116 0 115 215 0 215 0 0 65 0 65 -283 0 c-156 0 -286 -2 -288 -4z"
            fill={color}
          />
        </g>
      </svg>
    );
  })
)``;

Logo.defaultProps = {
  variant: 'primary',
};

Logo.propTypes = {
  variant: PropTypes.oneOf(['light', 'primary']),
};
